module.exports = __webpack_public_path__ + "static/media/sledding.c8c4afcb.svg";